import { defineComponent as w, useCssModule as q, inject as C, computed as T, toValue as x, createElementBlock as B, openBlock as b, unref as t, normalizeClass as s, createVNode as h, createBlock as I, createCommentVNode as y, renderSlot as M, withModifiers as N, withCtx as $ } from "vue";
import { t as V } from "./locale.js";
import z from "./Button.js";
import E from "./Icon.js";
import { _ as U } from "./Image.vue_vue_type_script_setup_true_lang-D5u4av0_.js";
import { T as d } from "./ThumbnailGroup.keys-EJ4qFNhx.js";
import { _ as j } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = ["aria-current", "draggable"], D = /* @__PURE__ */ w({
  __name: "Thumbnail",
  props: {
    thumbnail: {},
    altText: { default: "" },
    variant: { default: "opaque" }
  },
  emits: ["remove", "click"],
  setup(_, { emit: f }) {
    const u = _, r = f, a = q(), { thumbnails: v, activeThumbnail: n, draggable: p, isDragging: m, radius: i, removable: o } = C(
      d.key,
      d.defaults
    ), e = T(() => x(v).findIndex((l) => l === u.thumbnail));
    function g() {
      n.value = e.value, r("click", e.value);
    }
    function k() {
      r("remove", e.value), n.value = -1;
    }
    return (l, c) => (b(), B("li", {
      class: s(["stash-thumbnail tw-group tw-relative tw-cursor-pointer focus-visible:tw-outline-none", [
        {
          [t(a)["thumbnail-translucent"]]: u.variant === "translucent",
          [t(a)["thumbnail-opaque"]]: u.variant === "opaque",
          [t(a)["thumbnail-removable"]]: t(o),
          [t(a)["thumbnail-circle"]]: t(i) === "circle",
          [t(a)["thumbnail-rounded"]]: t(i) === "rounded"
        }
      ]]),
      "aria-current": t(n) === e.value,
      draggable: t(p),
      "data-test": "stash-thumbnail",
      tabindex: "0",
      onClick: c[0] || (c[0] = (L) => g())
    }, [
      h(U, {
        class: s(["stash-thumbnail__img tw-border-ice-200 tw-outline-blue-500/15 tw-transition-colors", [
          t(a)["thumbnail-img"],
          {
            [t(a)["thumbnail-mask"]]: t(o) && t(i) !== "circle",
            [t(a)["thumbnail-active"]]: t(n) === e.value && !t(m),
            "group-hover:tw-border-blue-500 group-focus-visible:tw-border-blue-500 group-focus-visible:tw-outline": !t(m)
          }
        ]]),
        "data-test": "stash-thumbnail|img",
        radius: t(i),
        src: l.thumbnail.imageUrl,
        alt: l.altText
      }, null, 8, ["class", "radius", "src", "alt"]),
      t(o) ? (b(), I(z, {
        key: 0,
        class: s(["stash-thumbnail__remove", [t(a)["thumbnail-remove"]]]),
        "data-test": "stash-thumbnail|remove",
        "aria-label": t(V)("ll.thumbnail.removeButton", { index: e.value + 1 }),
        type: "button",
        icon: "",
        onClick: N(k, ["stop", "prevent"])
      }, {
        default: $(() => [
          h(E, {
            name: "close",
            size: "small"
          })
        ]),
        _: 1
      }, 8, ["class", "aria-label"])) : y("", !0),
      M(l.$slots, "hint")
    ], 10, A));
  }
}), H = {
  "thumbnail-remove": "_thumbnail-remove_afa4q_2",
  "thumbnail-img": "_thumbnail-img_afa4q_24",
  "thumbnail-translucent": "_thumbnail-translucent_afa4q_32",
  "thumbnail-active": "_thumbnail-active_afa4q_36",
  "thumbnail-mask": "_thumbnail-mask_afa4q_46",
  "thumbnail-full": "_thumbnail-full_afa4q_50",
  "thumbnail-rounded": "_thumbnail-rounded_afa4q_54"
}, J = {
  $style: H
}, Q = /* @__PURE__ */ j(D, [["__cssModules", J]]);
export {
  Q as default
};
//# sourceMappingURL=Thumbnail.js.map
